import { takeLatest } from 'redux-saga';
import { fork, call, put, select } from 'redux-saga/effects';
import { fromJS } from 'immutable';
import {
  findInfluencers,
  countInfluencers,
  getInfluencer,
  runSearch,
  addInfluencer,
  addInfluencerDetails,
  addInfluencerLink,
  getOrganisationName,
} from '../../utils/jsonapi-functions/influencers';
import { getOrganisationId } from '../../selectors/user-selectors';
import {
  LOAD_INFLUENCERS,
  LOAD_INFLUENCERS_SUCCESS,
  LOAD_INFLUENCERS_ERROR,
  LOAD_SINGLE_INFLUENCER,
  LOAD_SINGLE_INFLUENCER_SUCCESS,
  LOAD_SINGLE_INFLUENCER_ERROR,
  SEARCH,
  SEARCH_ERROR,
  SEARCH_SUCCESS,
  ADD_INFLUENCER,
  ADD_INFLUENCER_EROR,
  ADD_INFLUENCER_SUCCESS,
  LOAD_ORGANISATION_NAME,
  LOAD_ORGANISATION_NAME_SUCCESS,
  LOAD_ORGANISATION_NAME_ERROR,
} from './constants';

export function* loadInfluencersData(action) {
  try {
    const { page } = action;
    const organisationId = yield select(getOrganisationId);
    const influencerData = yield call(findInfluencers, organisationId, page);
    const influencerCount = yield call(countInfluencers, organisationId);
    yield put({
      type: LOAD_INFLUENCERS_SUCCESS,
      data: fromJS(influencerData),
      count: influencerCount,
    });
  } catch (error) {
    yield put({ type: LOAD_INFLUENCERS_ERROR, data: error.title });
  }
}

export function* loadSingleInfluencerData(action) {
  try {
    const organisationId = yield select(getOrganisationId);
    const influencerData = yield call(getInfluencer, organisationId, action.id);
    yield put({ type: LOAD_SINGLE_INFLUENCER_SUCCESS, data: fromJS(influencerData) });
  } catch (error) {
    yield put({ type: LOAD_SINGLE_INFLUENCER_ERROR, data: error.title });
  }
}

export function* loadSearchData(action) {
  try {
    const { term } = action;
    const organisationId = yield select(getOrganisationId);
    const searchData = yield call(runSearch, organisationId, term);
    const searchArray = [];
    searchData.forEach(item => {
      const flattened = item.toJSON();
      const influencer = {
        title: flattened.name,
        description: flattened.primarySocialHandle,
        image: flattened.thumbnail,
      };

      searchArray.push(influencer);
    });
    yield put({ type: SEARCH_SUCCESS, data: searchArray });
  } catch (error) {
    yield put({ type: SEARCH_ERROR, data: error.title });
  }
}

export function* setInfluencerData(action) {
  try {
    const { data, details } = action;
    const influencerId = yield call(addInfluencer, data);
    const influencerDetailsId = yield call(addInfluencerDetails, details);
    const organisationId = yield select(getOrganisationId);
    yield call(addInfluencerLink, organisationId, influencerId, influencerDetailsId);
    yield put({ type: ADD_INFLUENCER_SUCCESS, data: 'Influencer successfully created!' });
  } catch (error) {
    yield put({ type: ADD_INFLUENCER_EROR, data: error.title });
  }
}

export function* loadOrganisationData() {
  try {
    const organisationId = yield select(getOrganisationId);
    const name = yield call(getOrganisationName, organisationId);
    yield put({ type: LOAD_ORGANISATION_NAME_SUCCESS, data: name.name });
  } catch (error) {
    yield put({ type: LOAD_ORGANISATION_NAME_ERROR, data: error.title });
  }
}

export function* watchLoadInfluencers() {
  yield takeLatest(LOAD_INFLUENCERS, loadInfluencersData);
}

export function* watchLoadSingleInfluencer() {
  yield takeLatest(LOAD_SINGLE_INFLUENCER, loadSingleInfluencerData);
}

export function* watchSearch() {
  yield takeLatest(SEARCH, loadSearchData);
}

export function* watchAddInfluencer() {
  yield takeLatest(ADD_INFLUENCER, setInfluencerData);
}

export function* watchLoadOrganisationName() {
  yield takeLatest(LOAD_ORGANISATION_NAME, loadOrganisationData);
}

export default function* InfluencersSaga() {
  yield [fork(watchLoadInfluencers)];
  yield [fork(watchLoadSingleInfluencer)];
  yield [fork(watchSearch)];
  yield [fork(watchAddInfluencer)];
  yield [fork(watchLoadOrganisationName)];
}



/** WEBPACK FOOTER **
 ** ./src/containers/influencers/sagas.js
 **/